import styled from "@emotion/styled";
export const StyledPlainBannerComponent = styled.div``;
